import { put, call, takeEvery, takeLatest } from "redux-saga/effects";
import {
  affiliateFilterAction,
  affiliateFilterCompleteAction,
  assignDriverAction,
  bookingDetailAction,
  getAssignedBookingsAction,
  totalAffiliateBokingAction,
} from "../../api/bookings/bookingAction";
import { toast } from "react-toastify";
import {
  getBookingDetails,
  getBookings,
  setBookingsLoading,
  setJobsForToday,
  setJobsForTodayLength,
  setJobsForTomorrow,
  setJobsForTomorrowLength,
  setUpcomingBooking,
  setUpcomingBookingLength,
  setTotalBookingCount,
  setFilteredBookings,
  setFilteredBookingsNumber,
  setNotFound,
  setIsSearch,
} from "../../redux/booking/booking-slice";

export function* assignedBookings(action) {
  try {
    yield put(
      setBookingsLoading({
        bookingsLoading: true,
      })
    );
    const response = yield call(getAssignedBookingsAction, action.payload);
    console.log("response from booking saGa bookings------->", response);
    if (response.status === 200) {
      yield put(
        setBookingsLoading({
          bookingsLoading: false,
        })
      );

      yield put(getBookings({ bookings: response?.data?.bookingDetails }));
      yield put(
        setUpcomingBooking({
          upcomingBooking: response?.data?.bookingDetailsUpcoming,
        })
      );
      yield put(
        setUpcomingBookingLength({
          upcomingBookingLength: response?.data?.bookingDetailsUpcominglength,
        })
      );
      yield put(
        setJobsForToday({
          jobsForToday: response?.data?.bookingDetailsToday,
        })
      );
      yield put(
        setJobsForTodayLength({
          jobsForTodayLength: response?.data?.bookingDetailsTodaylength,
        })
      );
      yield put(
        setJobsForTomorrow({
          jobsForTomorrow: response?.data?.bookingDetailsTomorrow,
        })
      );
      yield put(
        setJobsForTomorrowLength({
          jobsForTomorrowLength: response?.data?.bookingDetailsTomorrowlength,
        })
      );
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
}

export function* getBookingDetailSaga(action) {
  try {
    const response = yield call(bookingDetailAction, action.payload);

    if (response.status === 200) {
      yield put(
        getBookingDetails({ bookingDetails: response?.data?.bookingDetails })
      );
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
}

export function* assignDriverSaga(action) {
  try {
    const response = yield call(assignDriverAction, action.payload);

    console.log(action.payload, "action.payload");

    if (response.status === 200) {
      toast.success("Driver Assigned Successfully");

      yield put({
        type: "BOOKING_DETAILS",
        payload: {
          bookingId: action.payload.body.bookingId,
          token: action.payload.token,
        },
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
}

export function* totalBookingSaga(actions) {
  const response = yield call(totalAffiliateBokingAction, actions.payload);
  console.log("totalAffiliateBokingAction", response);
  yield put(
    setTotalBookingCount({
      totalBookingCount: response?.totalBookingCount,
    })
  );
}

export function* affiliateFilterSaga(action) {
  try {
    const response = yield call(affiliateFilterAction, action.payload);
    console.log("response from saga", response);

    yield put(
      setFilteredBookings({
        filteredBookings: response?.data?.filteredBooking,
      })
    );

    console.log("done");
    yield put(
      setFilteredBookingsNumber({
        filteredBookingsNumber: response?.data?.filteredBooking?.length,
      })
    );

    if (response?.data?.filteredBooking?.length > 0) {
      yield put(setNotFound({ notFound: false }));
    } else {
      yield put(setNotFound({ notFound: true }));
    }
    yield put(setIsSearch({ isSearch: true }));
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
}

export function* affiliateFilterCompleteSaga(action) {
  try {
    const response = yield call(affiliateFilterCompleteAction, action.payload);

    yield put(
      setFilteredBookings({
        filteredBookings: response?.data?.filteredBooking,
      })
    );
    yield put(
      setFilteredBookingsNumber({
        filteredBookingsNumber: response?.data?.filteredBookingsNumber,
      })
    );

    if (response?.data?.filteredBooking?.length > 0) {
      yield put(setNotFound({ notFound: false }));
    } else {
      yield put(setNotFound({ notFound: true }));
    }
    yield put(setIsSearch({ isSearch: true }));
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
}

export function* watchAssignedBookings() {
  yield takeEvery("BOOKING_ASSIGNED", assignedBookings);
  yield takeEvery("BOOKING_DETAILS", getBookingDetailSaga);
  yield takeEvery("ASSIGN_DRIVER", assignDriverSaga);
  yield takeEvery("TOTAL_BOOKING_COUNT", totalBookingSaga);
  yield takeLatest("FILTER_AFFILIATE", affiliateFilterSaga);
  yield takeLatest("FILTER_AFFILIATE_COMPLETE", affiliateFilterCompleteSaga);
}
